var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"d-flex align-items-center justify-content-center font-weight-bold cursor-pointer rounded-0 text-center my-primary w-100",attrs:{"disabled":_vm.isSubmitted},on:{"click":_vm.onClick}},[_c('h1',{staticClass:"text-white d-inline mr-3"},[_vm._v(_vm._s(_vm.saveText))]),(_vm.isSubmitted)?_c('b-spinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }